document.addEventListener('DOMContentLoaded', function () {
    const loader = document.getElementById('loader');
    const gstInput = document.getElementById('gst_number');
    const cartErrors = document.getElementById('cart-errors');
    const checkoutButton = document.getElementById('checkout'); // Checkout button
    const checkbox = document.getElementById('terms');
    var previousGST = '';
    const authKey = gstKey
    var gstMsg = '';    
    showLoader(false);

    // GST number regex pattern (for 15 characters: 2 digits, 10 alphanumerics, 1 digit, 1 letter, 1 checksum)
    const gstRegex = /^\d{2}[A-Z]{5}\d{4}[A-Z]{1}[A-Z\d]{1}[Z]{1}[A-Z\d]{1}$/;
    
    if (cartData.attributes && cartData.attributes.GSTNumber) {
        // Populate the input field with the GST number
        gstInput.value = cartData.attributes.GSTNumber;
        previousGST = cartData.attributes.GSTNumber;
        cartErrors.innerHTML = `<span style="color: green;">Verified</span>`;
        checkbox.disabled = false;
      } else {
        console.log("No GST Number available to populate.");
      }
      
    // Add blur event listener to gstInput
    gstInput.addEventListener('blur', function () {
        const gstNumber = gstInput.value.trim();

        if (gstNumber === '') {
            addAttributesToCart({ GSTNumber: '' , CompanyName: '' }).then(() => {
            });
            cartErrors.innerHTML = '';
            checkbox.disabled = false;
            return;         
        }
        
        if (!gstRegex.test(gstNumber)) {
            cartErrors.innerHTML = '<span style="color: red;">Invalid GST number format. Please check and try again.</span>';
            checkbox.disabled = true;
            checkoutButton.disabled = true;
            checkbox.checked = false;
            addAttributesToCart({ GSTNumber: '' , CompanyName: '' }).then(() => {
            }); 
            return;
        }

        // Clear any previous error messages and show the loader
        cartErrors.innerHTML = '';
        showLoader(true);
        checkoutButton.disabled = true;

        if(previousGST == gstNumber){
            showLoader(false);
            cartErrors.innerHTML = gstMsg
            return;
        }else{
            verifyGstNumber(authKey, gstNumber);
        }
        // Call the function to verify GST number
        // verifyGstNumber(authKey, gstNumber);
    });

    function showLoader(isLoading) {
        loader.style.display = isLoading ? 'block' : 'none';
    }

    function verifyGstNumber(apiKey, gstNumber) {
        previousGST = gstNumber;
        const url = `https://sheet.gstincheck.co.in/check/${apiKey}/${gstNumber}`;
        const xhr = new XMLHttpRequest();   

        xhr.open('GET', url, true);
        xhr.setRequestHeader('Content-Type', 'application/json; charset=utf-8');

        xhr.onload = function () {
            showLoader(false);

            if (xhr.status === 200) {
                try {
                    const gstData = JSON.parse(xhr.responseText);
                    const company = gstData?.data?.tradeNam;
                    if (gstData.flag === true) {
                        gstMsg = `<span style="color: green;">Verified</span>`;
                        cartErrors.innerHTML = gstMsg;
                        // msg = gstMsg;
                        // checkoutButton.disabled = false;
                        checkbox.disabled = false;

                        // Store GST number in the Shopify cart and redirect to checkout
                        addAttributesToCart({ GSTNumber: gstNumber, CompanyName: company  }).then(() => {
                            // window.location.href = '/checkout';
                        });
                    } else {
                        gstMsg = `<span style="color: red;">${gstData.message}</span>`;
                        cartErrors.innerHTML = gstMsg;
                        checkoutButton.disabled = true;
                        checkbox.disabled = true;
                        checkbox.checked = false; // Ensure the checkbox remains unchecked when disabled
                        addAttributesToCart({ GSTNumber: '' , CompanyName: ''}).then(() => {
                        }); 

                    }
                } catch (parseError) {
                    cartErrors.innerHTML = 'Invalid response from server.';
                    console.error('Parsing error:', parseError);
                    checkoutButton.disabled = true;
                }
            } else {
                gstMsg = `<span style="color: red;">Error verifying GST number (Status: ${xhr.status}).</span>`;
                cartErrors.innerHTML = gstMsg;
                console.error('Error', xhr.status, xhr.statusText);
                checkoutButton.disabled = true;
            }
        };

        xhr.onerror = function () {
            showLoader(false);
            gstMsg = '<span style="color: red;">Failed to verify GST number. Please try again later.</span>';
            cartErrors.innerHTML = gstMsg;
            // console.error('Network error occurred while verifying GST number.');
            checkoutButton.disabled = true;
        };
        xhr.send();
    }

    async function addAttributesToCart(attributes) {
        return fetch('/cart/update.js', {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json'
            },
            body: JSON.stringify({ attributes })
        })
        .then(response => {
            // console.log('Response status:', response.status);
            return response.json();
        })
        .then(data => {
            if (data && data.attributes) {
                // console.log('Cart updated successfully:', data);
            } else {
                // console.error('Cart response does not contain expected attributes:', data);
            }
        })
        .catch((error) => {
            console.error('Error updating cart attributes:', error);
        });
    }
});